import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import base_url from "../../api";
import "../LoginPage/LoginPage.css";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validToken, setValidToken] = useState(null);

  useEffect(() => {
    if (!token) {
      toast.error("Invalid or missing reset token.", { position: "top-right" });
      setValidToken(false);
    } else {
      // Verify token is valid
      verifyToken();
    }
  }, [token]);

  const verifyToken = async () => {
    try {
      const response = await fetch(`${base_url}/reset-password/verify-reset-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      });

      const data = await response.json();

      if (response.ok) {
        setValidToken(true);
      } else {
        setValidToken(false);
        toast.error(data.message || "Invalid or expired reset token.", {
          position: "top-right",
        });
      }
    } catch (err) {
      setValidToken(false);
      toast.error("Failed to verify token. Please try again.", {
        position: "top-right",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters long!", {
        position: "top-right",
      });
      return;
    }

    if (password.length > 50) {
      toast.error("Password must be less than 50 characters!", {
        position: "top-right",
      });
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!", { position: "top-right" });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${base_url}/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message || "Password reset successfully!", {
          position: "top-right",
          autoClose: 2000,
        });
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        toast.error(data.message || "Failed to reset password. Please try again.", {
          position: "top-right",
        });
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again later.", {
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  if (validToken === null) {
    return (
      <div className="login-page">
        <div className="login-left" style={{ maxWidth: "500px", margin: "0 auto" }}>
          <p>Verifying token...</p>
        </div>
        <ToastContainer />
      </div>
    );
  }

  if (validToken === false) {
    return (
      <div className="login-page">
        <div className="login-left" style={{ maxWidth: "500px", margin: "0 auto" }}>
          <h2>Invalid Reset Link</h2>
          <p style={{ marginBottom: "20px", color: "#666" }}>
            This password reset link is invalid or has expired. Please request a new one.
          </p>
          <Link to="/forgot-password" className="btn" style={{ display: "inline-block" }}>
            Request New Reset Link
          </Link>
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <Link to="/login" className="btn" style={{ display: "inline-block" }}>
              ← Back to Login
            </Link>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-left" style={{ maxWidth: "500px", margin: "0 auto" }}>
        <h2>Reset Password</h2>
        <p style={{ marginBottom: "20px", color: "#666" }}>
          Enter your new password below.
        </p>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group password-group">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New Password*"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
            />
            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="form-group password-group">
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm New Password*"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
            />
            <span
              className="toggle-password"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button type="submit" className="btn" disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>

        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <Link to="/login" style={{ color: "#b5651d", textDecoration: "none" }}>
            ← Back to Login
          </Link>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ResetPassword;

